import React from 'react';

interface ChevronIconProps {
  isExpanded?: boolean;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const ChevronIcon: React.FC<ChevronIconProps> = ({
  isExpanded = false,
  className = '',
  width = 12,
  height = 12,
  color = '#909090'
}) => {
  return (
    <div
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.2s ease-in-out',
        // Chevron points right by default, so:
        // - Collapsed (closed): rotate 0deg to point right
        // - Expanded (open): rotate 90deg to point down
        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 8 12"
        fill="none"
      >
        <path
          d="M7.00841 6.15383C7.02335 6.08234 7.04884 6.01291 7.04884 5.94025C7.04884 5.86759 7.02335 5.79816 7.00841 5.72667C6.99581 5.66633 6.99581 5.60422 6.97237 5.54649C6.94424 5.47676 6.89063 5.41847 6.84698 5.35519C6.81212 5.3045 6.79132 5.24723 6.7465 5.20196C6.74503 5.2005 6.74298 5.20021 6.74152 5.19873C6.74005 5.19726 6.73976 5.19522 6.73829 5.19375L1.78829 0.303527C1.37579 -0.104281 0.711335 -0.100765 0.303527 0.311735C-0.104281 0.724235 -0.100765 1.38986 0.311735 1.7965L4.50617 5.94024L0.311735 10.084C-0.100765 10.4906 -0.104281 11.1562 0.303527 11.5687C0.508607 11.7762 0.779303 11.8805 1.05001 11.8805C1.31603 11.8805 1.58322 11.7797 1.78829 11.577L6.73829 6.68671C6.73975 6.68525 6.74004 6.68319 6.74152 6.68173C6.74299 6.68027 6.74503 6.67998 6.7465 6.6785C6.79132 6.63324 6.81212 6.57596 6.84698 6.52527C6.89064 6.462 6.94424 6.40369 6.97237 6.33397C6.99581 6.27625 6.99581 6.21419 7.00841 6.15383Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ChevronIcon;
